// This is a navigation projection only; the API independently authorizes every call.
export function lateSubmissionPoliciesAvailable() {
    return window.__INITIAL_STATE__?.EnvironmentSettings?.late_submission_policies_enabled === true;
}

// Mirrors PolicyAccess: only permissions held through a global role count.
function grantedByRole(user, permission) {
    return !!user?.roles?.some(role => role.permissions?.some(granted => granted.name === permission));
}

export function canManageLateSubmissionPolicies(user) {
    return lateSubmissionPoliciesAvailable() && grantedByRole(user, 'manage late submission policies');
}

// The staff report has its own permission, so a role can read it without managing policies.
export function canViewLateSubmissionDeductionsReport(user) {
    return lateSubmissionPoliciesAvailable() && grantedByRole(user, 'view late submission deductions report');
}

export function canConfigureLateSubmissionPolicies(user) {
    return canManageLateSubmissionPolicies(user) && grantedByRole(user, 'configure late submission policy scope');
}

// Moving courses onto another policy changes those courses, so it needs its own permission.
export function canChangeCourseLateSubmissionPolicies(user) {
    return lateSubmissionPoliciesAvailable() && grantedByRole(user, 'change course late submission policy');
}
